export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20abstract%20composition%20with%20deep%20crimson%20red%20and%20dark%20charcoal%20tones%2C%20mysterious%20atmosphere%20with%20soft%20spotlight%20effects%2C%20stylized%20newspaper%20and%20digital%20media%20elements%20blended%20abstractly%2C%20cinematic%20lighting%20with%20high%20contrast%20shadows%2C%20editorial%20photography%20style%2C%20warm%20gold%20accents%20on%20dark%20background%2C%20elegant%20and%20moody%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="91黑料网 - 黑料吃瓜爆料平台"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/50 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-300 text-xs font-label font-semibold tracking-wider mb-4 whitespace-nowrap">
              🔥 每日黑料 · 实时吃瓜
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-white leading-tight tracking-tight">
              91黑料网 — 最新黑料吃瓜爆料第一站
            </h1>

            <p className="mt-3 font-heading text-lg md:text-xl text-accent-300 font-semibold tracking-wide">
              新鲜八卦 · 一手黑料 · 每日更新
            </p>

            <p className="mt-6 text-sm md:text-base text-white/75 leading-relaxed max-w-xl mx-auto lg:mx-0">
              91黑料网专注娱乐黑料与吃瓜爆料，每日实时更新最新黑料事件与八卦视频。
              平台汇集全网热门91黑料资源，覆盖明星八卦、网红翻车、行业揭秘等多元内容，
              以最快速度呈现91黑料网站首页最新入口，为吃瓜群众提供便捷的一站式浏览体验。
              当前平台持续追踪多个重量级黑料事件，内容覆盖广泛且更新迅速。
            </p>

            <div className="mt-8 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8">
              {[
                { value: '24h', label: '全天更新' },
                { value: '3000+', label: '黑料资源' },
                { value: '98%', label: '用户好评' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="font-heading text-2xl md:text-3xl font-black text-white">
                    {stat.value}
                  </div>
                  <div className="text-xs text-white/55 mt-1 whitespace-nowrap">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white font-label font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer text-center"
              >
                查看最新爆料
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 rounded-lg border border-white/25 text-white font-label font-semibold text-sm whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer text-center"
              >
                热门榜单排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20composition%20with%20deep%20crimson%20and%20dark%20tones%2C%20abstract%20representation%20of%20entertainment%20gossip%20and%20breaking%20news%2C%20layered%20newspaper%20textures%20with%20digital%20glitch%20effects%2C%20mysterious%20silhouette%20elements%2C%20cinematic%20lighting%20with%20warm%20gold%20highlights%2C%20high%20contrast%20editorial%20photography%20style%2C%20modern%20media%20aesthetic&width=800&height=700&seq=hero-visual-01&orientation=portrait"
                alt="91黑料网 - 最新黑料吃瓜爆料"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-white text-xs font-label font-semibold whitespace-nowrap">
                  实时追踪 · 最新爆料
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}